import { loanProcessingDefinitionsApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const TIMED_SEQUENCE_ACTION_TYPE = createNamedActions('timedSequence', {
  GET_TIMED_SEQUENCE_SCHEMA: 'GET_TIMED_SEQUENCE_SCHEMA',
});

export const getTimedSequenceSchemaAction = catchAsyncActionError(() => async dispatch => {
  const { data } = await loanProcessingDefinitionsApi.getTimedSequenceExpressionDefinition();

  return dispatch({
    type: TIMED_SEQUENCE_ACTION_TYPE.GET_TIMED_SEQUENCE_SCHEMA,
    payload: data,
  });
});
